module.exports = __webpack_public_path__ + "img/fiorimpopoli2.28abb7ad.jpeg";